import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/about/HeroSection';
import StorySection from '../components/about/StorySection';
import ValuesSection from '../components/about/ValuesSection';
import TestimonialsSection from '../components/about/TestimonialsSection';
import CTASection from '../components/about/CTASection';

function AboutUs() {
  return (
    <div className="bg-white">
      <Helmet>
        <title>Chi Siamo | Molinaro Immobiliare | Agenzia Immobiliare Scandicci</title>
        <meta name="description" content="Scopri la storia di Molinaro Immobiliare, agenzia immobiliare a Scandicci dal 2017. Conosciamo ogni angolo di Scandicci e trasformiamo case in luoghi da vivere." />
        <meta name="keywords" content="agenzia immobiliare Scandicci, Molinaro Immobiliare, chi siamo, storia agenzia immobiliare, team immobiliare Scandicci" />
        <link rel="canonical" href="https://www.molinaroimmobiliare.it/chi-siamo" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.molinaroimmobiliare.it/chi-siamo" />
        <meta property="og:title" content="Chi Siamo | Molinaro Immobiliare | Agenzia Immobiliare Scandicci" />
        <meta property="og:description" content="Scopri la storia di Molinaro Immobiliare, agenzia immobiliare a Scandicci dal 2017. Conosciamo ogni angolo di Scandicci e trasformiamo case in luoghi da vivere." />
        <meta property="og:image" content="https://www.molinaroimmobiliare.it/images/agenzia4.jpeg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.molinaroimmobiliare.it/chi-siamo" />
        <meta property="twitter:title" content="Chi Siamo | Molinaro Immobiliare | Agenzia Immobiliare Scandicci" />
        <meta property="twitter:description" content="Scopri la storia di Molinaro Immobiliare, agenzia immobiliare a Scandicci dal 2017. Conosciamo ogni angolo di Scandicci e trasformiamo case in luoghi da vivere." />
        <meta property="twitter:image" content="https://www.molinaroimmobiliare.it/images/agenzia4.jpeg" />
      </Helmet>
      <HeroSection />
      <StorySection />
      <ValuesSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
}

export default AboutUs;